import React from 'react'
import { Box, Button, IconButton, Paper, Stack, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { blueGrey, grey } from '@mui/material/colors'
import UpdateIcon from '@mui/icons-material/Update'
import { getAppTitle } from 'common/utils'
import { JmaAlertContainer } from './JmaAlertContainer'
import { useGlobalState } from 'state'
import dayjs from 'dayjs'


type RightContainerProps = {
  width: number
}

export const RightContainer = ({width}: RightContainerProps) => {
  const state = useGlobalState()

  const moveLatestDate = () => {
    state.app.setBaseDate(dayjs.utc())
  }

  return (
    <Box sx={{borderLeft: '1px solid #9e9e9e'}}>
      <Paper sx={{width, backgroundColor: blueGrey[900], height: '100dvh'}} elevation={0} square>
        <Stack direction="row" justifyContent="end" sx={{height: 35}}>
          <IconButton size='small' onClick={() => state.app.setRightContainer(false)}>
            <CloseIcon sx={{color: grey[500]}} fontSize='small' />
          </IconButton>
        </Stack>
        <Stack direction="column" justifyContent="center" alignItems="center" sx={{height: 120}}>
          <Typography variant='h6' fontWeight={'bold'} color={grey[300]}>
            { getAppTitle() }
          </Typography>
          <Typography variant='body2' color={grey[300]} sx={{mt: 1, mb: 1}}>
            { state.app.baseDate.local().format('YYYY年MM月DD日 HH:mm') }
          </Typography>
          <Button variant='contained' size='small' startIcon={<UpdateIcon fontSize='inherit' />} sx={{backgroundColor: '#555fa1'}} onClick={moveLatestDate}>
            最新時刻に更新
          </Button>
        </Stack>
        <Stack sx={{height: 'calc(100dvh - 252px)'}}>
          <JmaAlertContainer />
        </Stack>
        <Paper sx={{height: 80, backgroundColor: blueGrey[800], m: 1, p: 1}}>
          <Typography component='div' variant='caption' fontWeight='bold' color={grey[100]}>お知らせ</Typography>
          <Typography component='div' variant='caption' color={grey[300]}>お知らせは現在ありません。</Typography>
        </Paper>
      </Paper>
    </Box>
  )
}
